import { useEffect, useState } from 'react';

import type { ChooseWhereToSavePayload } from '../components/ChooseWhereToSaveModal/ChooseWhereToSaveModal';

export type PendingTripSave = {
  tripId: number | null;
  isNewTrip: boolean;
};

export function useDiscoverStoppableSaveFlow(open: boolean) {
  const [saveError, setSaveError] = useState<string | null>(null);
  const [scheduleStep, setScheduleStep] = useState(false);
  const [pendingTripSave, setPendingTripSave] = useState<PendingTripSave | null>(null);

  useEffect(() => {
    if (!open) {
      setSaveError(null);
      setScheduleStep(false);
      setPendingTripSave(null);
    }
  }, [open]);

  const openTripSchedule = (pending: PendingTripSave) => {
    setPendingTripSave(pending);
    setScheduleStep(true);
    setSaveError(null);
  };

  const closeTripSchedule = () => {
    setScheduleStep(false);
    setPendingTripSave(null);
  };

  const beginTripSaveFromChoose = (payload: ChooseWhereToSavePayload) => {
    if (payload.tripId == null) {
      setSaveError('Select a trip to save.');
      return false;
    }
    openTripSchedule({ tripId: payload.tripId, isNewTrip: false });
    return true;
  };

  const beginNewTripSave = () => {
    openTripSchedule({ tripId: null, isNewTrip: true });
  };

  return {
    saveError,
    setSaveError,
    chooseOpen: open && !scheduleStep,
    scheduleOpen: open && scheduleStep,
    pendingTripSave,
    closeTripSchedule,
    openTripSchedule,
    beginTripSaveFromChoose,
    beginNewTripSave,
  };
}
